const _version = "3.3.0"
function version() {
    return _version
}
export default version
